module.exports = __webpack_public_path__ + "img/1P.0084fea7.jpg";